export default {
  add_popup: 'Adicionar',
};
